import React, { useEffect, useRef, useState } from 'react'
import {
  Autocomplete,
  AutocompleteChangeReason,
  AutocompleteRenderInputParams,
  Checkbox,
  InputBase,
  MenuItem,
} from '@mui/material'
import { styled } from '@mui/system'
import { ValueFormatterParams } from 'ag-grid-community'
import {
  CustomEnumValue,
  FunctionProperty,
} from '../../../../../../../../lib/commons/appFunction'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'

const RootDiv = styled('div')({
  width: '100%',
  height: '100%',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
})
const StyledMenuItem = styled(MenuItem)({
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  '& .MuiCheckbox-root': { marginRight: '0px !important' },
  '& .MuiAvatar-root': { margin: '0px 6px 0px 0px !important' },
})

interface Props {
  value: CustomEnumValue[]
  uiMeta: FunctionProperty
  onValueChange: (value: any) => void
}

export const multiSelectCellValueFormatter = (params: ValueFormatterParams) => {
  if (!params.value || !Array.isArray(params.value)) {
    return ''
  }
  return params.value.map(v => v.name).join(', ')
}

const MultiSelectCellEditor = (props: Props) => {
  const [value, setValue] = useState<CustomEnumValue[] | undefined>(props.value)
  const [open, setOpen] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- マウント時のみ実行。セルエディタの初期化処理
  }, [])

  const handleValueChanged = (
    _event: React.ChangeEvent<{}>,
    newOptions: CustomEnumValue[] | null,
    _reason: AutocompleteChangeReason
  ) => {
    const newValue = newOptions || []
    props.onValueChange(newValue)
    setValue(newValue)
    setOpen(false)
  }

  const { uiMeta } = props
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
  const checkedIcon = <CheckBoxIcon fontSize="small" />

  return (
    <RootDiv>
      <Autocomplete
        multiple={true}
        options={uiMeta.valuesAllowed}
        getOptionLabel={option => (option.name ? option.name : '')}
        renderOption={(renderProps, option, { selected }) => {
          return (
            <StyledMenuItem {...renderProps}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
                color={'primary'}
              />
              <span>{option.name}</span>
            </StyledMenuItem>
          )
        }}
        renderInput={(params: AutocompleteRenderInputParams) => (
          <InputBase
            inputRef={inputRef}
            ref={params.InputProps.ref}
            inputProps={params.inputProps}
            autoFocus={true}
          />
        )}
        isOptionEqualToValue={(optionValue, option) => {
          return optionValue.value === option.value
        }}
        filterOptions={(options: CustomEnumValue[]) => {
          return options.filter(option => {
            return option.value !== 'NONE'
          })
        }}
        autoSelect={false}
        blurOnSelect={false}
        value={value}
        onChange={handleValueChanged}
        disableCloseOnSelect={true}
      />
    </RootDiv>
  )
}

export default MultiSelectCellEditor
